import { render, staticRenderFns } from "./ConfigurationSideMenu.vue?vue&type=template&id=711232fa&scoped=true&"
import script from "./ConfigurationSideMenu.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationSideMenu.vue?vue&type=style&index=0&id=711232fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711232fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VFlex,VIcon,VLayout})
